module.exports = __webpack_public_path__ + "media/images/icons/flags/BI-597afbf9c30a5503c4663a41576ac3c3.svg";